import axios from "axios";

const API_URL = "https://sora.imet.gr/api/id_areas";

let areaCache = null;
let areaPromise = null;

const toGeometryCandidate = (geometry) => {
  if (!geometry?.type || !geometry?.coordinates) return null;

  return {
    type: geometry.type,
    coordinates: geometry.coordinates,
  };
};

const pickBestAreaGeometry = (area) => {
  const candidates = [
    toGeometryCandidate(area?.geom),
    toGeometryCandidate(area?.geometry),
    toGeometryCandidate(area?.linestring?.geometry),
  ].filter(Boolean);

  const polygonCandidate = candidates.find(
    (candidate) =>
      candidate.type === "Polygon" || candidate.type === "MultiPolygon"
  );

  return polygonCandidate || candidates[0] || { type: "Polygon", coordinates: [] };
};

export async function fetchArea() {
  if (areaCache) return areaCache;
  if (areaPromise) return areaPromise;

  areaPromise = axios
    .get(API_URL, {
      headers: { "Accept-Profile": "traffic_monitoring" },
    })
    .then((response) => {
      const raw = response.data || [];
      const filtered = raw.filter((area) => area.area_id !== 100);

      areaCache = filtered
        .map((area, index) => {
          const areaId = area.area_id ?? area.id ?? area.id_area ?? index;
          const name = area.name || `Area ${areaId}`;
          const nameEl = area.name_el || name;
          const geometry = pickBestAreaGeometry(area);
          const color = area.color || "#FF8800";

          return {
            id: areaId,
            area_id: areaId,
            name,
            name_el: nameEl,
            geometry,
            properties: {
              color,
              borderColor: color,
              hoverMessage: nameEl || name,
            },
            monitoringType: "area",
            raw: area,
          };
        })
        .sort((a, b) => a.area_id - b.area_id);

      areaPromise = null;
      return areaCache;
    })
    .catch((error) => {
      areaPromise = null;
      console.error("Error fetching areas:", error);
      throw error;
    });

  return areaPromise;
}
